// The diff algorithms the Files view offers, with what each is good for.
import type { DiffAlgorithm } from '../engine/types';

export interface AlgorithmOption {
  id: DiffAlgorithm;
  label: string;
  /** When the algorithm helps, for the option's tooltip. */
  title: string;
}

export const ALGORITHMS: readonly AlgorithmOption[] = [
  {
    id: 'reindent',
    label: 'Reindent-tolerant',
    title:
      'Aligns lines as if indentation did not matter, so code moved in or out a level (an extracted function body, a new wrapping block) sits beside its old version. Reindented lines still show as changed. Best for refactors.',
  },
  {
    id: 'histogram',
    label: 'Unique-line anchors',
    title:
      'Histogram diff: aligns on lines that occur once, such as signatures, and never matches common lines like } across unrelated code. Reindented code shows as removed and added.',
  },
  {
    id: 'myers',
    label: 'Fewest lines (as GitHub)',
    title:
      'Myers diff: the fewest changed lines, aligned as git and GitHub show them. Can match common lines like } or ) across unrelated code.',
  },
];

export const DEFAULT_ALGORITHM: DiffAlgorithm = 'reindent';

/** `value` when it names an offered algorithm, else the default (a stored preference may be stale or edited). */
export function algorithmOf(value: unknown): DiffAlgorithm {
  return ALGORITHMS.some((a) => a.id === value) ? (value as DiffAlgorithm) : DEFAULT_ALGORITHM;
}
